export const STORE_KEY = 'wc-braintree/store/checkout';